function imagemapAreas(message) {
  const width = Number(message?.baseSize?.width);
  const height = Number(message?.baseSize?.height);
  if (!width || !height) return [];
  return (message.actions || []).map(action => ({
    x: Number(action?.area?.x || 0) / width,
    y: Number(action?.area?.y || 0) / height,
    w: Number(action?.area?.width || 0) / width,
    h: Number(action?.area?.height || 0) / height
  }));
}

export function toLineChatPreviewMessages(messages) {
  if (!Array.isArray(messages)) return [];

  return messages.map((message) => {
    if (message?.type === 'text') {
      return {
        role: 'bot',
        messageType: 'text',
        textContent: message.text || '',
        textEmojis: message.emojis || []
      };
    }
    if (message?.type === 'image') {
      return {
        role: 'bot',
        messageType: 'image',
        imageUrl: message.originalContentUrl || message.previewImageUrl || ''
      };
    }
    if (message?.type === 'video') {
      return {
        role: 'bot',
        messageType: 'video',
        previewImageUrl: message.previewImageUrl || ''
      };
    }
    if (message?.type === 'imagemap') {
      return {
        role: 'bot',
        messageType: 'imagemap',
        imagemapUrl: message.baseUrl || '',
        imagemapAreas: imagemapAreas(message)
      };
    }
    if (message?.type === 'template' && message.template?.type === 'image_carousel') {
      return {
        role: 'bot',
        messageType: 'image_carousel',
        carouselItems: (message.template.columns || []).map(column => ({
          imageUrl: column.imageUrl || '',
          label: column.action?.label || ''
        }))
      };
    }
    if (message?.type === 'flex') {
      return {
        role: 'bot',
        messageType: message.contents?.type === 'carousel' ? 'flex_carousel' : 'flex',
        flexContent: message.contents || null
      };
    }
    return {
      role: 'bot',
      messageType: message?.type || 'unknown'
    };
  });
}
